import DreamdataAwareUiEvents from 'client/GrowthEngineering/Dreamdata/DreamdataAwareUiEvents';
import DreamdataEvents from 'client/GrowthEngineering/Dreamdata/DreamdataEvents';

let registered = false;

/**
 * Registers window.DreamdataUiEvents / window.DreamdataEvents once. Called from bootstrap when
 * analytics is enabled - not on module import - so disableAnalytics does not create queues/timers.
 */
export function registerDreamdataGlobals() {
  if (registered) return;
  registered = true;

  const dreamdataAwareUiEvents = DreamdataAwareUiEvents();

  window.DreamdataUiEvents = dreamdataAwareUiEvents;
  window.DreamdataEvents = {
    ...DreamdataEvents,
    init() {
      DreamdataEvents.init(dreamdataAwareUiEvents.markDreamdataReady.bind(dreamdataAwareUiEvents));
    },
  };
}

export default {
  registerDreamdataGlobals,
};
